import { render, staticRenderFns } from "./SearchResultsHeaderLayout.vue?vue&type=template&id=2413212e&scoped=true"
import script from "./SearchResultsHeaderLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchResultsHeaderLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchResultsHeaderLayout.vue?vue&type=style&index=0&id=2413212e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2413212e",
  null
  
)

export default component.exports